<div class="pv-shell">
    <div class="container">

        <div class="page-header no-print">
            <div class="page-header-icon" [style.background]="'rgba(255,255,255,0.15)'" [style.color]="'#fff'">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                </svg>
            </div>
            <div style="flex: 1;">
                <h1>Central de Relatórios</h1>
                <p>{{ relatorioSelecionado ? relatorioSelecionado.nome : 'Selecione um relatório na lista fixa' }}</p>
            </div>
            <div class="no-print" style="display: flex; gap: 10px;">
                <button type="button" class="btn-primario" *ngIf="dadosResultado.length" (click)="imprimir()">
                    Imprimir Relatório
                </button>
            </div>
        </div>

        <div *ngIf="relatorioSelecionado" class="card no-print">
            <div class="card-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                     stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
                </svg>
                Filtros do Relatório
            </div>

            <div class="form-grid filters-grid-alignment">
                <div class="form-subgroup">
                    <label class="form-label">Data Inicial</label>
                    <input type="date" class="form-input" (ngModelChange)="aoMudarDataInicial($event)" [(ngModel)]="filtros.dataInicial">
                </div>

                <div class="form-subgroup">
                    <label class="form-label">Data Final</label>
                    <input type="date" class="form-input" [(ngModel)]="filtros.dataFinal">
                </div>

                <div class="form-subgroup">
                    <label class="form-label">Vendedor</label>
                    <div class="busca-combo">
                        <button type="button" class="btn-busca" 
                                (click)="abrirBuscaVendedor()" 
                                title="Buscar Vendedor"
                                *ngIf="vendedores.length > 1">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <circle cx="11" cy="11" r="7"></circle>
                                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                            </svg>
                        </button>
                        <input type="text" class="busca-combo-input"
                               [value]="valorExibidoVendedor(codVendSelecionado)"
                               [title]="valorExibidoVendedor(codVendSelecionado)"
                               (input)="onInputVendedor($event)"
                               [readonly]="vendedores.length === 1"
                               placeholder="Código ou apelido do vendedor...">
                        <button type="button" class="busca-combo-clear" *ngIf="codVendSelecionado && vendedores.length > 1" (click)="limparVendedor()" title="Limpar">
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>

                <div class="form-subgroup">
                    <label class="form-label">Tipo de Movimento</label>
                    <select class="form-input" [(ngModel)]="filtros.tipoFiltro">
                        <option value="VENDIDO">Faturado</option>
                        <option value="RECEBIDO">Faturado + Recebido</option>
                    </select>
                </div>

                <div class="form-subgroup actions-filter-group">
                    <button type="button" class="btn-primario" (click)="buscarDadosRelatorioComissaoVendedor()">
                        Consultar
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="carregando()" class="loading-overlay">
            <app-loading-indicator></app-loading-indicator>
        </div>

        <div class="sintetico-section" 
            [class.esconder-na-impressao]="alvoImpressao === 'ANALITICO'" 
            *ngIf="valorComissaoFormatado !== 'R$ 0,00' || listaComissaoPorVendedor.length > 0" 
            style="margin-top: 24px; padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

            <button class="no-print" (click)="imprimirSintetico()"
                    style="display: flex; align-items: center; gap: 8px; background-color: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; padding: 6px 16px; border-radius: 6px; font-weight: 500; cursor: pointer; transition: all 0.2s;">
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                    <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                </svg>
                Imprimir Resumo
            </button>

            <h4 style="margin-bottom: 20px; color: #334155; font-weight: 600;">Resumo de Comissões</h4>

            <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 30px; page-break-inside: avoid;">

                <div class="card sintetico-card" *ngFor="let vend of listaComissaoPorVendedor" style="padding: 0; overflow: hidden; transition: all 0.2s;">

                    <div (click)="vend.expandido = !vend.expandido" 
                        style="display: flex; justify-content: space-between; align-items: center; padding: 16px 20px; cursor: pointer; background: #fff;"
                        onmouseover="this.style.backgroundColor='#f8fafc'" 
                        onmouseout="this.style.backgroundColor='#fff'">
                        
                        <div style="display: flex; align-items: center; gap: 12px; font-size: 15px; font-weight: 700; color: #1a5d7c;">
                            
                            <svg [style.transform]="vend.expandido ? 'rotate(180deg)' : 'rotate(0)'" 
                                style="transition: transform 0.3s ease; color: #94a3b8;" 
                                width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>

                            <span>Vendedor: {{ vend.codvend }} - {{ vend.nome }}</span>
                        </div>

                        <div style="font-size: 14px; color: #64748b; font-weight: 600; display: flex; align-items: center; gap: 8px;">
                            Total a Receber: 
                            <span style="font-size: 18px; font-weight: 700; color: #10b981;">
                                {{ vend.valorFormatado }}
                            </span>
                        </div>
                    </div>

                    <div [style.display]="vend.expandido ? 'block' : 'none'" class="accordion-body" style="padding: 20px; border-top: 1px solid #e2e8f0; background: #fcfcfd;">
                        
                        <div style="font-size: 13px; font-weight: 700; color: #334155; margin-bottom: 12px; text-transform: uppercase; letter-spacing: 0.5px;">
                            Composição do Valor
                        </div>

                        <div style="background: #f1f5f9; padding: 12px 16px; border-radius: 6px; border: 1px solid #e2e8f0; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                            <span style="font-size: 13px; font-weight: 600; color: #475569;">Faturamento Total:</span>
                            <span style="font-size: 16px; font-weight: 700; color: #1e293b;">
                                {{ formatarMoeda(vend.faturamentoFormatado) }}
                            </span>
                        </div>

                        <div *ngIf="!vend.comissoes || vend.comissoes.length === 0" class="text-muted" style="font-size: 13px;">
                            Nenhuma faixa de comissão processada.
                        </div>

                        <div *ngFor="let f of vend.comissoes" style="display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px dashed #e2e8f0; font-size: 13px;">
                            <span class="font-mono" style="color: #475569; white-space: pre-wrap;">{{ f.textoComposicao }}</span>
                            <span class="font-bold" style="color: #10b981;">{{ formatarMoeda(f.valorComissao) }}</span>
                        </div>
                        
                    </div>
                    
                </div>
            </div>

            <div class="no-print" style="margin-top: 30px; padding-top: 20px; border-top: 1px solid #e2e8f0; text-align: center;">
                
                <ng-container *ngIf="(codVendSelecionado && listaComissaoPorVendedor.length === 1); else avisoVendedorObrigatorio">
                    <p class="text-muted" style="margin-bottom: 12px; font-size: 13px;">Deseja conferir as notas que compõem os valores acima?</p>
                    <button class="btn-primario" (click)="gerarRelatorioAnalitico()" [disabled]="carregandoAnalitico">
                        <app-loading-indicator *ngIf="carregandoAnalitico" size="inline"></app-loading-indicator>
                        <i *ngIf="!carregandoAnalitico" class="fa fa-list-alt"></i>
                        {{ carregandoAnalitico ? 'Buscando Notas...' : 'Gerar Relat&oacute;rio Anal&iacute;tico' }}
                    </button>
                </ng-container>

                <ng-template #avisoVendedorObrigatorio>
                    <p class="text-muted no-print" style="margin-bottom: 4px; font-size: 13px; color: #64748b; font-weight: 500;">
                        * Para visualizar e imprimir o Detalhamento Anal&iacute;tico por item, filtre por um vendedor espec&iacute;fico.
                    </p>
                </ng-template>

                <div *ngIf="mensagemAnalitico" class="text-danger" style="margin-top: 10px; font-size: 13px; color: var(--danger);">
                    {{ mensagemAnalitico }}
                </div>
            </div>
        </div>

        <div class="analitico-section" 
            [class.esconder-na-impressao]="alvoImpressao === 'SINTETICO'" 
            *ngIf="dadosAnaliticos.length > 0" 
            style="margin-top: 24px; padding: 20px; background: #fff; border-radius: 8px; box-shadow: 0 1px 3px rgba(0,0,0,0.1);">

            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px;">
                <h4 style="margin: 0; color: #334155; font-weight: 600;">Detalhamento por {{ demonstrativoTipoAnalitico === 'VENDA' ? 'Venda' : 'Item' }}</h4>

                <div class="detalhamento-filter-buttons no-print">
                    <button
                        type="button"
                        class="filter-chip"
                        [class.active]="demonstrativoTipoAnalitico === 'VENDA'"
                        (click)="alternarDetalhamento('VENDA')">
                        Por Venda
                    </button>
                    <button
                        type="button"
                        class="filter-chip"
                        [class.active]="demonstrativoTipoAnalitico === 'ITEM'"
                        (click)="alternarDetalhamento('ITEM')">
                        Por Item
                    </button>
                </div>

                <button class="no-print" (click)="imprimirAnalitico()"
                        style="display: flex; align-items: center; gap: 8px; background-color: #f1f5f9; color: #475569; border: 1px solid #cbd5e1; padding: 6px 16px; border-radius: 6px; font-weight: 500; cursor: pointer; transition: all 0.2s;">
                    <svg width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z"/>
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z"/>
                    </svg>
                    Imprimir Detalhamento
                </button>
            </div>
            <div class="validity font-mono no-print">Todas as vendas listadas est&atilde;o faturadas e todos os valores já estão considerando o que foi devolvido.</div>
            <table class="itens-table" style="width: 100%; border-collapse: collapse;">
                <thead class="print-header">
                <tr style="background: #f1f5f9; text-align: left;">
                    <th style="padding: 10px; width: 8%;">Nº &Uacute;NICO</th>
                    <th style="padding: 10px; width: 8%;">Nota</th>
                    <th style="padding: 10px;">CLIENTE</th>
                    <th style="padding: 10px; width: 10%;">COM</th>
                    <th style="padding: 10px; width: 8%;">PREFIXO</th>
                    <th style="padding: 10px; width: 10%;">DT FINALIZA&Ccedil;&Atilde;O</th>
                    <th style="padding: 10px; width: 8%;" *ngIf="!modoAgrupado">P/N</th>
                    <th style="padding: 10px; width: 15%;" *ngIf="!modoAgrupado">PRODUTO</th>
                    <th style="padding: 10px; width: 3%;" *ngIf="!modoAgrupado">%DESC</th>
                    <th style="padding: 10px; width: 9%; text-align: right;">VLR TOTAL</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let item of dadosAnaliticos; let par = even" 
                    [ngStyle]="{'background-color': par ? '#ffffff' : '#f8fafc'}"
                    style="border-bottom: 1px solid #e2e8f0; page-break-inside: avoid;">
                    <td style="padding: 10px;" class="font-mono">{{ item.nunota }}</td>
                    <td style="padding: 10px;" class="font-mono">{{ item.numnota }}</td>
                    <td style="padding: 10px;" class="font-mono">{{ obterNomeCliente(item) }}</td>
                    <td style="padding: 10px;" class="font-mono">{{ item.com }}</td>
                    <td style="padding: 10px;" class="font-mono">{{ item.prefixo }}</td>
                    <td style="padding: 10px;" class="font-mono">{{ item.dtneg }}</td>
                    <td style="padding: 10px;" class="font-mono" *ngIf="!modoAgrupado">{{ item.pn }}</td>
                    <td style="padding: 10px;" class="font-mono" *ngIf="!modoAgrupado">{{ item.nomeProduto }}</td>
                    <td style="padding: 10px;" class="font-mono" *ngIf="!modoAgrupado">{{ formatarPercentual(item.percDesc) }}</td>
                    <td style="padding: 10px; text-align: right;">{{ item.isAgrupamento ? formatarMoeda(item.valorTotalVenda) : formatarMoeda(item.vlrTotItem) }}</td>
                </tr>
                </tbody>
            </table>

            <div style="display: grid; gap: 30px; align-items: start; margin-top: 30px; page-break-inside: avoid;">
                <div class="card sintetico-card" *ngFor="let vend of listaComissaoPorVendedor">
                    <div style="display: flex; justify-content: space-between; align-items: center; cursor: pointer; background: #fff;">
                        <div style="display: flex; align-items: center; gap: 12px; font-size: 15px; font-weight: 700; color: #1a5d7c;">
                            <span>Vendedor: {{ vend.nome }}</span>
                        </div>

                        <div style="font-size: 14px; color: #64748b; font-weight: 600; display: flex; align-items: center; gap: 8px;">
                            Total a Receber: 
                            <span style="font-size: 18px; font-weight: 700; color: #10b981;">
                                {{ vend.valorFormatado }}
                            </span>
                        </div>
                    </div>
                    <div class="card-title" style="font-size: 14px; font-weight: 600; margin-bottom: 12px;">Composição do Valor</div>

                    <div style="background: #f1f5f9; padding: 12px 16px; border-radius: 6px; border: 1px solid #e2e8f0; margin-bottom: 20px; display: flex; justify-content: space-between; align-items: center;">
                        <span style="font-size: 13px; font-weight: 600; color: #475569;">Faturamento Total:</span>
                        <span style="font-size: 16px; font-weight: 700; color: #1e293b;">
                            {{ formatarMoeda(vend.faturamentoFormatado) }}
                        </span>
                    </div>

                    <div *ngFor="let f of vend.comissoes" style="display: flex; justify-content: space-between; padding: 8px 0; border-bottom: 1px dashed #e2e8f0; font-size: 13px;">
                        <span class="font-mono">{{ f.textoComposicao }}</span>
                        <span class="font-bold" style="color: #10b981;"> {{ formatarMoeda(f.valorComissao) }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="quick-sale-empty no-print" *ngIf="!dadosResultado.length && !carregando()">
            {{ buscaMensagem }}
        </div>

    </div>
</div>

<div class="modal-overlay" *ngIf="vendedorModalAberta">
    <div class="modal-box">
        <div class="modal-header">Procurando por Vendedor</div>
        <div class="modal-body">
            <input type="text" #inputNomeVendedor class="busca-modal-input" [(ngModel)]="filtroVendedor" placeholder="Digite o nome do vendedor" autofocus>
            <div class="busca-modal-lista">
                <div class="busca-modal-item" *ngFor="let v of vendedoresFiltrados" (click)="selecionarVendedor(v)">
                    {{ v.codVend }} - {{ v.apelido }}
                </div>
                <div class="busca-modal-empty" *ngIf="vendedoresFiltrados.length === 0">
                    Nenhum vendedor encontrado.
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="modal-btn confirm" (click)="fecharBuscaVendedor()">Cancelar</button>
        </div>
    </div>
</div>